import axios from "axios";

// Same-origin, relative: the API is always served from the same host as the
// app itself (nginx.conf proxies /api/ -> backend:8001 in the container; CRA's
// dev server does the same via src/setupProxy.js). Deliberately NOT an
// absolute URL from an env var -- a build-time REACT_APP_BACKEND_URL is baked
// into the bundle and, if it ever disagrees with the origin the page was
// loaded from, every request dies as a mixed-content block (http:// value on
// an https:// page) or a CORS failure, with the whole app broken and nothing
// but the browser console to say why.
const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export function formatApiError(detail) {
  // null when there's nothing to format (e.g. a network-level failure with
  // no response body at all) -- every caller chains `|| e.message` after
  // this, so returning a truthy generic string here would permanently mask
  // the real error (a network/CORS failure's genuinely useful e.message,
  // like "Network Error") and it would never be shown or logged.
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
